export default class LocationModel {
  constructor (data) {
    this.positions = []
    this.logentries = []
    this.organisation = null

    this.values = {
      id: null,
      organisation_id: null,
      business: null,
      postaddress: null,
      postzipcode: null,
      postcity: null,
      postregion: null,
      postcountry: null,
      phone: null,
      email: null,
      fax: null,
      website: null,
      visitaddress: null,
      visitzipcode: null,
      visitcity: null,
      visitregion: null,
      visitcountry: null
    }

    window.PRIM.modelMapper.mapToModel(data, this.values)
  }
  getTitle () {
    return [this.values.business].join(' ')
  }
  getSubtitle () {
    let subtitle = []

    if (this.values.visitcity) {
      subtitle.push(this.values.visitcity)
    }

    if (this.organisation) {
      subtitle.push(this.organisation.values.name)
    }

    return subtitle.join(' ')
  }
  getImage () {
    if (this.organisation) {
      return this.organisation.getImage()
    } else {
      return null
    }
  }
  getIndex () {
    if (this.getCompareString()) {
      return this.getCompareString().substring(0, 1).toUpperCase()
    }

    return null
  }
  getCompareString () {
    let title = []

    if (this.values.business) {
      title.push(this.values.business)
    }

    if (this.values.visitcity) {
      title.push(this.values.visitcity)
    }

    if (this.organisation) {
      title.push(this.organisation.values.name)
    }

    return title.join(' ')
  }

  getJSON () {
    let result = {}

    window.PRIM.modelMapper.mapToObject(this.values, result)

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/location/model/LocationModel.js